import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import IntlStore from "stories/IntlStore";
import Back from "assets/back.svg";
import { Title } from "../components/Title";
import { Text } from "../components/Text";

interface VerifyProps {
  onResend: () => Promise<void>;
  onBack: () => void;
}

let interval: ReturnType<typeof setInterval>;
const INIT_SECONDS = 30;

export const Verify: React.FC<VerifyProps> = props => {
  const [seconds, setSeconds] = useState(INIT_SECONDS);

  useEffect(() => {
    interval = setInterval(() => {
      setSeconds(prev => {
        const newSeconds = prev - 1;

        if (interval && newSeconds === 0) {
          clearInterval(interval);
        }

        return newSeconds;
      });
    }, 1000);
  }, []);

  const onResendClick = async () => {
    try {
      await props.onResend();
      setSeconds(INIT_SECONDS);
      interval = setInterval(() => {
        setSeconds(prev => {
          const newSeconds = prev - 1;

          if (interval && newSeconds === 0) {
            clearInterval(interval);
          }

          return newSeconds;
        });
      }, 1000);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Container>
      <BackButton onClick={props.onBack}>
        <Back color="#B2B2B2" />
        <FormattedMessage id="Auth.SignUp.Verify.Back" defaultMessage="Back"/>
      </BackButton>
      <Title>
        <FormattedMessage id="Auth.SignUp.Verify.Title" defaultMessage="Verify your account"/>
      </Title>
      <Subtitle>
        <FormattedMessage id="Auth.SignUp.Verify.Subtitle" defaultMessage="We've sent a confirmation link to your email address. Please click the link to verify your account and complete registration"/>
      </Subtitle>
      {seconds === 0
        ? (
          <ResendButton onClick={onResendClick}>
            <FormattedMessage id="Auth.SignUp.Verify.ResendButton" defaultMessage="Resend"/>
          </ResendButton>
        )
        : (
          <Resend>
            {IntlStore.intl.formatMessage({
              id: "Auth.SignUp.Verify.ResendInfo",
              defaultMessage: "Didn't receive the email? Resend in {seconds} seconds"
            }, { seconds })}
          </Resend>
        )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Subtitle = styled(Text)`
  font-size: 16px;
  line-height: 26px;
`;

const Resend = styled.div`
  font-size: 13px;
  line-height: 19px;
  color: #7E7E7E;
`;

const ResendButton = styled.a`
  font-size: 13px;
  line-height: 19px;
  color: #6777FF;
  cursor: pointer;
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 16px;
  color: #B2B2B2;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
`;
